module.exports = __webpack_public_path__ + "img/parking-lot-2.4188cab2.jpg";